import Promise from 'bluebird'
import opentype from 'opentype.js'

class LogoMaker {
  constructor (params) {
    this.fontUrl = params.fontUrl
    this.svgSize = params.svgSize
    this.textSize = params.textSize
    this.text = params.text || ''
    this.textColor = params.textColor
    this.fontFamily = params.fontFamily || 'Arial'
    this.position = params.position || 'left'
    this.iconSize = params.iconSize
    this.iconSVG = params.iconSVG
    this.iconScale = params.iconScale
  }

  make () {
    return this.createSVG()
  }

  createSVG () {
    let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    svg.setAttribute('width', this.svgSize.width + 5)
    svg.setAttribute('height', this.svgSize.height + 5)

    return this.loadFont(this.fontFamily)
      .then((font) => this.addText(svg, font, this.text))
      .then(() => this.addIcon(svg))
      .then(() => svg)
  }

  getIconCoords () {
    var x = 0
    var y = 0
    var iconSize = this.iconSVG.getBBox()

    if (this.position === 'left' || this.position === 'right') {
      y = (-iconSize.y * this.iconScale) + (this.svgSize.height / 2 - iconSize.height * this.iconScale / 2)
    } else if (this.position === 'bottom') {
      y = -iconSize.y + this.svgSize.height - iconSize.height * this.iconScale + 5
    }

    if (this.position === 'top' || this.position === 'bottom') {
      x = this.svgSize.width / 2 - (iconSize.width * this.iconScale) / 2 - iconSize.x * this.iconScale
    } else if (this.position === 'right') {
      x = (this.svgSize.width - iconSize.x) - iconSize.width * this.iconScale
    } else {
      x = -iconSize.x * this.iconScale
    }

    return {
      x: x,
      y: y
    }
  }

  addIcon (svg) {
    var g = document.createElementNS('http://www.w3.org/2000/svg', 'g')
    g.innerHTML = this.iconSVG.innerHTML
    g.setAttribute('fill', this.iconSVG.getAttribute('fill'))
    svg.appendChild(g)

    var coords = this.getIconCoords()
    g.setAttribute('transform', 'matrix(' + this.iconScale + ', 0, 0, ' + this.iconScale + ', ' + coords.x + ', ' + coords.y + ')')

    return true
  }

  getTextCoords () {
    var x = 0
    var y = 0

    if (this.position === 'left' || this.position === 'right') {
      y = this.svgSize.height / 2 + this.textSize.height / 2 + this.iconScale - 5
    } else if (this.position === 'top') {
      y = this.svgSize.height - 5
    } else if (this.position === 'bottom') {
      y = this.textSize.height - 5
    }

    if (this.position === 'left') {
      x = this.svgSize.width - this.textSize.width - 3
    }

    return {
      x: x,
      y: y
    }
  }

  addText (svg, font, text) {
    let coords = this.getTextCoords()
    svg.innerHTML = font.getPath(text, coords.x, coords.y, 32).toSVG()
    svg.querySelector('path').setAttribute('fill', this.textColor)
    return true
  }

  loadFont (fontName) {
    return new Promise((resolve, reject) => {
      opentype.load(this.fontUrl, (err, font) => {
        if (err) {
          reject(err)
        } else {
          resolve(font)
        }
      })
    })
  }
}

export default LogoMaker



// WEBPACK FOOTER //
// ./src/logomaker.js